import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AttributeList from 'tradera-components/attributes/attribute-list';
import SearchIcon from '@tradera/blueprint/theme/icons2/search.svg?jsx';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';
import { useTranslator } from 'tradera-lang/translate';

import './attribute-modal.scss';
import DialogModal from 'tradera-components/dialog/dialog-modal';

const AttributeModal = ({
    options,
    defaultSelected,
    onClose,
    selectAction,
    singleSelect,
    title,
    translateOptions,
    parameter
}) => {
    const [search, setSearch] = useState('');
    const [selectedAttribute, setSelectedAttribute] = useState(defaultSelected);

    const { t } = useTranslator();

    const handleSelect = attribute => {
        if (singleSelect) {
            setSelectedAttribute([attribute]);
        } else {
            if (selectedAttribute.includes(attribute)) {
                setSelectedAttribute(
                    selectedAttribute.filter(selected => selected !== attribute)
                );
            } else {
                setSelectedAttribute([...selectedAttribute, attribute]);
            }
        }
    };

    const handleInputChange = input => setSearch(input.substr(0, 10));

    const handleAttributeSave = () => {
        selectAction(selectedAttribute, !selectedAttribute.isActive);
        onClose();
    };

    const filteredAttributes = options
        .filter(attribute => {
            return attribute.value.toLowerCase().includes(search.toLowerCase());
        })
        .sort((a, b) => {
            if (a.value > b.value) {
                return 1;
            } else if (a.value < b.value) {
                return -1;
            } else {
                return 0;
            }
        });

    return (
        <DialogModal
            className="attribute-modal-wrapper"
            onDismiss={() => {
                onClose();
            }}>
            <div className="attribute-modal bg-white d-flex flex-column text-inter h-100 w-100 overflow-hidden">
                <div className="attribute-modal--header bg-white d-flex justify-content-between p-2">
                    <button
                        className="btn btn-outline-danger"
                        onClick={() => {
                            onClose();
                        }}>
                        {t('syi_draft_editor_attribute_modalCancel')}
                    </button>
                    <h1 className="m-auto size-london text-styled mb-0">
                        {title}
                    </h1>
                    <button
                        className="btn btn-primary"
                        disabled={!selectedAttribute}
                        onClick={() => handleAttributeSave(selectedAttribute)}>
                        {t('syi_draft_editor_attribute_modalSave')}
                    </button>
                </div>
                <div className="d-flex p-2 border-bottom attribute-modal--search">
                    <div className="form-control-with-icon w-100 h-100">
                        <input
                            type="text"
                            className="form-control form-control-rounded"
                            placeholder={t(
                                'syi_draft_editor_attribute_searchPlaceholder'
                            )}
                            aria-label={t(
                                'syi_draft_editor_attribute_searchPlaceholder'
                            )}
                            aria-describedby="search-brand"
                            value={search}
                            autoFocus={true}
                            onChange={e => handleInputChange(e.target.value)}
                        />
                        {search ? (
                            <button
                                className="clear-button unbutton icon"
                                onClick={() => setSearch('')}>
                                <CloseIcon className="icon icon-dark" />
                            </button>
                        ) : (
                            <SearchIcon className="icon icon-dark mr-2" />
                        )}
                    </div>
                </div>
                <AttributeList
                    attributes={filteredAttributes}
                    setSelected={handleSelect}
                    selected={selectedAttribute}
                    parameter={parameter}
                    translateOptions={translateOptions}
                />
            </div>
        </DialogModal>
    );
};

AttributeModal.defaultProps = {
    defaultSelected: []
};

AttributeModal.propTypes = {
    options: PropTypes.array.isRequired,
    defaultSelected: PropTypes.array,
    selectAction: PropTypes.func,
    singleSelect: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string,
    translateOptions: PropTypes.bool,
    parameter: PropTypes.string
};

export default AttributeModal;
